import CONSTANTS from "../../Constants";
import fetchApiData from "../../apiHandlers/fetchApiData";
import { pushEventToGTM } from "../../helpers/trackerManager";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { setBasketId } from "../../redux-files/actions/action";
import MobileYourQuoteHeader from "../Operations/MobileOperationsComponents/MobileYourQuoteHeader";
import { Button, Input } from "../Forms/Forms";
import { useNavigate } from "react-router-dom";
import './MobileMailPopinForm.scss'


const MobileMailPopinForm = ({ handleGoBackClick }) => {

    const selectedForfaitFromStore = useSelector(state => state.ndel_store.selectedForfaits)
    const selectedMandatoryAdditionalForfFromStore = useSelector(state => state.ndel_store.selectedMandatoryAdditionalForfaits)
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const dealer = useSelector(state => state.ndel_store.dealer)
    const selectedMileageStepCode = useSelector(state => state.ndel_store.selectedMileageSteps.key)

    const [emailInput, setEmailInput] = useState('')
    const [emailErrorLabel, setEmailErrorLabel] = useState('')
    const [showReceiveEmailPopIn, setShowReceiveEmailPopIn] = useState(false)
    const [sendingEmailLoader, setSendingEmailLoader] = useState(false)
    const [showMailError, setShowMailError] = useState(false)
    const exactBackgroundImage = showReceiveEmailPopIn ? 'mailSent' : 'mailForm'
    const LoadingClass = (sendingEmailLoader ? " Loading" : "");

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const sendQuoteMail = () => {
        setSendingEmailLoader(true)
        let foraitsFamilyCodes = []
        let forfaitsRef = []
        selectedForfaitFromStore.forEach((forfait) => {
            forfaitsRef.push(forfait.Items[0].Ref)
            foraitsFamilyCodes.push(forfait.forfaitFamilyCode)
        })
        selectedMandatoryAdditionalForfFromStore.forEach((Mandforfait) => {
            forfaitsRef.push(Mandforfait.Items[0].Ref)
        })

        const fetchApi = new fetchApiData()
        fetchApi.getSendQuoteMail({
            "carDetails": { ...vehicleInfo },
            "dealerInfos": { ...dealer },
            "customerEmail": emailInput,
            "mileageStep": selectedMileageStepCode,
            "selectedServices": {
                // comment: this.props.store.commentServices,
                "subFunctionCodes": { ...foraitsFamilyCodes },
                "forfaitRefs": { ...forfaitsRef },
            },
            "listeInterventions": [],
        }).then(
            result => {
                if (result.d.Statut === 0) {
                    setSendingEmailLoader(false)
                    setShowReceiveEmailPopIn(true)
                    dispatch(setBasketId(result.d.BasketId))
                }
                else {
                    setSendingEmailLoader(false)
                    console.error('une erreur s\'est produite')
                }
            })
            .catch(error => {
                setSendingEmailLoader(false)
                console.error(error)
            });
        pushEventToGTM({
            pageName: 'quoting',
            eventAction: 'Display::Popin::Email',
            eventLabel: CONSTANTS.LABELS.quote_email2,
            eventCategory: 'Content'
        })
    }
    const handleEmailChange = (e) => {
        const mailRegExp = new RegExp('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}')
            if (e.target.value.length <= 0 || mailRegExp.test(e.target.value)) {
                setEmailErrorLabel('')
            }
    }
    const checkMailValidity = (input = emailInput) => {
        const mailRegExp = new RegExp('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}')
        if (input.length > 0 && !mailRegExp.test(input)) {
            setEmailErrorLabel(
                CONSTANTS.LABELS.userinfos_error.replace("[nom_du_champ]", CONSTANTS.LABELS.userinfos_email)
            )
            return false
        } else {
            setEmailErrorLabel('')
            return true
        }

    }
    return (
        <div className='popin-overlay'>
            <div className={`mailForm-popin ${exactBackgroundImage}`}>
                <MobileYourQuoteHeader handleClick={handleGoBackClick} />
                {!showReceiveEmailPopIn ? <div className={`container ${LoadingClass}`}> {/*show the form email */}
                    <h1 tabIndex='0' >{CONSTANTS.LABELS.quote_email1}</h1>
                    <Input
                        placeholder={CONSTANTS.SITE_INFO.EMAILMASK}
                        label={CONSTANTS.LABELS.userinfos_email}
                        onChange={(e) => {
                            // handleEmailInputChange
                            setEmailInput(e.target.value.toLowerCase().trim());
                            handleEmailChange(e)
                            // checkMailValidity(e.target.value);
                            console.log(emailInput,' ', e.target.value)
                        }

                        }
                        errorLabel={emailErrorLabel}
                        Value={emailInput}
                    // onBlur={(e) => {
                    //     setShowMailError(true)
                    //     checkMailValidity(e)
                    // }
                    // }
                    />
                    <Button isDisabled={emailInput.length < 1}
                        handlClick={() => {
                            if (checkMailValidity()) {
                                sendQuoteMail()
                            }
                        }
                        }
                    >
                        {CONSTANTS.LABELS.quote_email2}
                    </Button>
                </div>
                    :
                    <div className='container'> {/*show the confirmation that the email has been sent */}
                        <p tabIndex='0' className='text-info'>{CONSTANTS.LABELS.quote_popin_email_label1}</p>
                        <Button isDisabled={emailInput.length < 1}
                            handlClick={() => navigate(CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE) /*history.push(CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE)*/}
                        >
                            {CONSTANTS.LABELS.quote_booking}
                        </Button>
                    </div>
                }
            </div>
        </div>
    );
}
export default MobileMailPopinForm;